import Component from '@glimmer/component';

import CButton from 'rise-ui/components/c-button.gjs';
import CField from 'rise-ui/components/c-field.gjs';
import CFieldHeight from 'rise-ui/components/c-field-height.gjs';
import LocationMap from 'rise-ui/components/location-map.gjs';
import join from 'rise-ui/helpers/join.js';
import joinKeys from 'rise-ui/helpers/join-keys.js';
import latLngCollection from 'rise-ui/helpers/lat-lng-collection.js';
import linkToMapForLocation from 'rise-ui/helpers/link-to-map-for-location.js';
import or from 'rise-ui/helpers/or.js';
import string from 'rise-ui/helpers/string.js';

export default class LocationDetailDetailComponent extends Component {
  <template>
    <div class="id-location-detail__location">
      <div class="id-location-detail__location-fields">
        {{#let (join @location.tags) as | locationTags |}}
        <CFieldHeight class="id-location-detail__field--location-tags">
          <CField
            @label={{string "location-tags-label"}}
            title={{or locationTags (string "location-tags-empty")}}
            @value={{locationTags}}
          />
        </CFieldHeight>
        {{/let}}
        {{#let @location.parentLocation.name as | parentLocationName |}}
        <CFieldHeight class="id-location-detail__field--location-parent">
          <CField
            @label={{string "location-parent-label"}}
            title={{or parentLocationName (string "location-parent-empty")}}
            @value={{parentLocationName}}
          />
        </CFieldHeight>
        {{/let}}
        {{#let (joinKeys @location.states "name") as | locationStates |}}
        <CFieldHeight class="id-location-detail__field--states">
          <CField
            @label={{string "location-states-label"}}
            title={{or locationStates (string "location-states-empty")}}
            @value={{locationStates}}
          />
        </CFieldHeight>
        {{/let}}
        {{#let (join @location.unifiedRegions) as | unifiedRegions |}}
        <CFieldHeight class="id-location-detail__field--unified-regions">
          <CField
            @label={{string "location-unified-regions-label"}}
            title={{or unifiedRegions (string "location-unified-regions-empty")}}
            @value={{unifiedRegions}}
          />
        </CFieldHeight>
        {{/let}}
        {{#let (join @location.reclamationRegions) as | reclamationRegions |}}
        <CFieldHeight class="id-location-detail__field--reclamation-regions">
          <CField
            @label={{string "location-reclamation-regions-label"}}
            title={{or reclamationRegions (string "location-reclamation-regions-empty")}}
            @value={{reclamationRegions}}
          />
        </CFieldHeight>
        {{/let}}
        <CFieldHeight class="id-location-detail__field--timezone">
          <CField
            @label={{string "location-timezone-label"}}
            title={{or @location.timezone (string "location-timezone-empty")}}
            @value={{@location.timezone}}
          />
        </CFieldHeight>
        <CFieldHeight class="id-location-detail__field--elevation">
          <CField
            @label={{string "location-elevation-label"}}
            title={{or @location.elevation (string "location-elevation-empty")}}
            @value={{@location.elevation}}
            @empty="[ N/A ]"
          />
        </CFieldHeight>
        <CFieldHeight class="id-location-detail__field--vertical-datum">
          <CField
            @label={{string "location-vertical-datum-label"}}
            title={{or @location.verticalDatum (string "location-vertical-datum-empty")}}
            @value={{@location.verticalDatum}}
            @empty="[ N/A ]"
          />
        </CFieldHeight>
        {{#let (latLngCollection @location.coordinates) as | coordinates |}}
        <CFieldHeight class="id-location-detail__field--coordinates">
          <CField
            @label={{string "location-coordinates-label"}}
            title={{or coordinates (string "location-coordinates-empty")}}
            @value={{coordinates}}
            @empty="[ N/A ]"
          />
        </CFieldHeight>
        {{/let}}
        <CFieldHeight class="id-location-detail__field--horizontal-datum">
          <CField
            @label={{string "location-horizontal-datum-label"}}
            title={{or @location.horizontalDatum (string "location-horizontal-datum-empty")}}
            @value={{@location.horizontalDatum}}
            @empty="[ N/A ]"
          />
        </CFieldHeight>
      </div>
      <div class="id-location-detail__map-container">
        {{#if @location.coordinates}}
          <LocationMap class="id-location-detail__map" @location={{@location}} />
        {{/if}}
        <CButton
          @classMix="id-location-detail__button--map-location"
          @linkToExternal={{linkToMapForLocation @location}}
        >
          {{string "location-map-link"}}
        </CButton>
      </div>
    </div>
  </template>
}
